export function buildUserCountText({
  count,
  noneText = null,
}: {
  count: number;
  noneText?: string | null;
}) {
  if (count === 1) {
    return "1 user";
  } else if (count > 1) {
    return `${count} users`;
  } else {
    return noneText;
  }
}
